import { Component, Input } from '@angular/core';
import {
  DailyLogOperationInstance
} from '../../../../../models/projects/operation.models';

@Component({
  selector: 'transit-preview-operation-list',
  templateUrl: 'transit-preview-operation-list.html'
})
export class TransitPreviewOperationListComponent {
  @Input() operationInstances: DailyLogOperationInstance[];

  constructor() {

  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/shared/components/transit-preview/transit-preview-operation-list/transit-preview-operation-list.ts